import React, { useState, useEffect, useRef, forwardRef } from "react";
import useLoader from "hooks/useLoader";
import { AddEvent_ESC } from "library/Library";
import useFormV1 from "hooks/useFormV1";
import Attachments, { ShowAttachments } from "layout/attachments/Attachments";
import useDeepEffect from "hooks/useDeepEffect";
import Card from "layout/card/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";
import useModalStack, { ModalPopUp } from "hooks/useModalStack";
import { ApiRequest, UrlParams } from "library/APICall";
import { ResponseSnackbar, ShowSnackbar } from "layout/snackbar/Snackbar";

const DEFAULT_ATTACHED_DOCUMENTS = (
  <span className="as-text-light">Files not uploaded!</span>
);

export const UploadSignature = forwardRef(
  ({ pop, open, setOpenSignaturePopup }, ref) => {
    const attachmentRef = useRef();
    const [isLoading, setLoaderStatus, loading] = useLoader();

    const [attachments, setAttachments] = useState([]);
    const [attachedDocuments, setAttachedDocuments] = useState(
      DEFAULT_ATTACHED_DOCUMENTS
    );

    const [attachmentChanged, setAttachmentChanged] = useState(false);
    const [attachmentVisible, setAttachmentVisible] = useState(false);

    const [modal, push, popModal] = useModalStack();

    const DefaultValue = () => ({});
    const ValidateSchema = () => ({});

    const { form, handle, fun, validate } = useFormV1(
      DefaultValue,
      ValidateSchema
    );

    useEffect(() => {
      const removeEscHandler = AddEvent_ESC(pop);
      return () => removeEscHandler();
    }, [pop]);

    useEffect(() => {
      setLoaderStatus("get", true);
      var data = {
        user_name: localStorage.user_name
      };
      ApiRequest({
        TYPE: "GET",
        URL: "/app/setup/Users/getmysignature?" + UrlParams(data),
        CALLBACK: function (res) {
          ResponseSnackbar(res);
          if (res.error_code == 0) {
            var data = res.data.user_signature;
            console.log("dataattachment", data);
            setAttachments(data?.attachment_id ?? []);
          }
        },
        COMPLETE: function () {
          setLoaderStatus("get", false);
        },
        DATA: {},
      });
    }, []);

    useEffect(() => {
      setAttachmentVisible(true);
    }, []);

    useEffect(() => {
      if (attachmentVisible && attachmentRef.current?.setShow) {
        attachmentRef.current.setShow(true);
      }
    }, [attachmentVisible]);

    useDeepEffect(() => {
      if (attachments && attachments.length > 0) {
        setAttachedDocuments(
          <ShowAttachments
            attachmentIds={attachments}
            showOnPopUp={false}
            forceReload={attachmentChanged}
          />
        );
      } else {
        setAttachedDocuments(DEFAULT_ATTACHED_DOCUMENTS);
      }
    }, [attachments, attachmentChanged]);

    const handleFooterAction = (ids) => {
      
      const attachmentIds =
        ids ?? attachmentRef.current?.getAttachmentId?.() ?? [];
      

        setAttachments(attachmentIds);
        setAttachmentChanged((prev) => !prev);
        setAttachmentVisible(false);
        setOpenSignaturePopup(false);

        if (attachmentRef.current?.setShow) {
            attachmentRef.current.setShow(false);
        }
        

        //this is kept so that api will not be contiuously hit when there is not upload and deletion of the  attachments
        const hasChanged =JSON.stringify(attachmentIds) != JSON.stringify(attachments);
        if(hasChanged){
            Save(attachmentIds);
        }
    };

   const footerAction = () => {
    return (
      <span style={{ color: 'red' }}>
        <div>
        <strong>&nbsp;&nbsp;NOTE:</strong><br />
          &nbsp;&nbsp;• Maximum File Size: 1MB<br />
          &nbsp;&nbsp;• Image size adjusts automatically. Ensure the signature is fully visible and not cropped.<br />
          &nbsp;&nbsp;• Image Type: PNG
        </div>

      </span>
    );
  };

    const attachmentProps = {
      attachmentIds: attachments,
      ref: attachmentRef,
      footerAction: handleFooterAction,
      allowed_format: ["png"], 
      number_of_files : 1,
      show_close_button:false,
      footer_action:footerAction()
    };

   

    const Save = (attachmentIds) => {
      debugger;
      if (isLoading("save")) {
        return;
      }
      // if (!attachmentIds || attachmentIds.length == 0) {
      //   return;
      // }

      var inputdata = {
        attachment_id: Array.isArray(attachmentIds)
          ? attachmentIds
          : [attachmentIds],
      };

      setLoaderStatus("save", true);

      ApiRequest({
        TYPE: "POST",
        URL: "/app/setup/Users/setusersignature",
        CALLBACK: function (res) {
          ResponseSnackbar(res);
          // if (res.error_code == 0) {
          //
          // }
        },
        COMPLETE: function () {
          setLoaderStatus("save", false);
        },
        DATA: inputdata,
      });
    };

    return (
      <>
        {loading(true)}
        {modal}
        <Card title="" titleDescription="" titleIcon={faFileSignature}>
          <div className="as-form-wrapper">
            <div className="col-7 col-m-12 col-s-12 col-x-12">
              <Attachments {...attachmentProps} showFooterAction={true} />
            </div>
          </div>
        </Card>
      </>
    );
  }
);
